import type { IdeaDTO } from "./api";
import { readJson, writeJson } from "./storage";

const KEY = "saaslots:last_spin_v1";

export interface LastSpin {
  idea: IdeaDTO;
  finalIndices: [number, number, number];
}

export function loadLastSpin(): LastSpin | null {
  const parsed = readJson<Partial<LastSpin> | null>(KEY, null);
  if (!parsed || !parsed.idea || !Array.isArray(parsed.finalIndices)) return null;
  if (parsed.finalIndices.length !== 3) return null;
  return parsed as LastSpin;
}

export function saveLastSpin(spin: LastSpin): void {
  writeJson(KEY, spin);
}
